export const PAGE_DEFAULTS = {
  home: {
    pageKey: 'home',
    displayName: 'Home',
    path: '/',
    isEnabled: true,
    content: {
      subtitle: 'IT Consultancy • Solutions • Services',
      heroTitle: 'Smart technology solutions for modern business',
      heroLead:
        'From bespoke web design and internal systems to Azure cloud services and disaster recovery — we deliver IT that works for you.',
      ctaTitle: 'Ready to transform your IT?',
      ctaText:
        "Let's discuss how we can help your business leverage technology for real results.",
    },
  },
  about: {
    pageKey: 'about',
    displayName: 'About',
    path: '/about',
    isEnabled: true,
    content: {
      subtitle: 'About Us',
      title: 'The people behind the technology',
      intro:
        'Founded on the belief that technology should empower businesses, not complicate them.',
    },
  },
  services: {
    pageKey: 'services',
    displayName: 'What We Do',
    path: '/services',
    isEnabled: true,
    content: {
      subtitle: 'What We Do',
      title: 'Our services',
      intro:
        'A comprehensive range of IT services designed to cover every aspect of your technology needs — from strategic planning to hands-on delivery.',
    },
  },
  'our-work': {
    pageKey: 'our-work',
    displayName: 'Our Work',
    path: '/our-work',
    isEnabled: true,
    content: {
      subtitle: 'Our Work',
      title: "Projects we're proud of",
      intro:
        'A selection of recent engagements showcasing the range and depth of our work across industries and technologies.',
    },
  },
  contact: {
    pageKey: 'contact',
    displayName: 'Contact',
    path: '/contact',
    isEnabled: true,
    content: {
      subtitle: 'Get In Touch',
      title: "Let's talk about your project",
      email: 'hello@knowitsolutions.co.uk',
      phone: '+44 (0) 123 456 7890',
      location: 'United Kingdom',
    },
  },
};

export const PAGE_ORDER = ['home', 'about', 'services', 'our-work', 'contact'];

export const PAGE_CONTENT_FIELDS = {
  home: [
    { key: 'subtitle', label: 'Hero Subtitle' },
    { key: 'heroTitle', label: 'Hero Title' },
    { key: 'heroLead', label: 'Hero Lead', multiline: true },
    { key: 'ctaTitle', label: 'CTA Title' },
    { key: 'ctaText', label: 'CTA Text', multiline: true },
  ],
  about: [
    { key: 'subtitle', label: 'Section Subtitle' },
    { key: 'title', label: 'Section Title' },
    { key: 'intro', label: 'Intro Text', multiline: true },
  ],
  services: [
    { key: 'subtitle', label: 'Section Subtitle' },
    { key: 'title', label: 'Section Title' },
    { key: 'intro', label: 'Intro Text', multiline: true },
  ],
  'our-work': [
    { key: 'subtitle', label: 'Section Subtitle' },
    { key: 'title', label: 'Section Title' },
    { key: 'intro', label: 'Intro Text', multiline: true },
  ],
  contact: [
    { key: 'subtitle', label: 'Section Subtitle' },
    { key: 'title', label: 'Section Title' },
    { key: 'email', label: 'Contact Email' },
    { key: 'phone', label: 'Contact Phone' },
    { key: 'location', label: 'Contact Location' },
  ],
};
